// common localized variables that are different in US, CA, UK, IE
export const localeName = "UK"; 
export const color = "colour";
export const colorCapitalized = "Colour";
export const phoneNumber = "0800 055 6196";
export const quartzPath = "//cdn.4imprint.co.uk/qtz";
export const productImagePath = "https://cdn.4imprint.co.uk/prod";
export const regSM = "SM";
export const certainDeliveryParagraph = "It's on time or it's on us. If your event is missed because we didn't dispatch on time, your order is free.";
export const certainHappinessParagraph = "100% satisfaction guaranteed, your goods will be printed exactly as per your artwork proof, or we'll reprint your order or send you a refund.";